import { RefObject, useEffect } from 'react';

type Event = MouseEvent | TouchEvent;

export const useOnClickOutside = (
  ref: RefObject<HTMLElement>,
  handler: (event: Event) => void
): void => {
  useEffect(() => {
    const listener = (event: Event): void => {
      const el = ref?.current;
      const target = event?.target as Node;

      if (!el || el.contains(target)) {
        return;
      }

      // Check if click is within a Radix UI portal (e.g., popover content)
      if ((target as Element).closest('[data-radix-popper-content-wrapper]')) {
        return;
      }

      handler(event);
    };
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Esc' || event.key === 'Escape') {
        handler(event as unknown as Event);
      }
    };
    document.addEventListener(`mousedown`, listener);
    document.addEventListener(`touchstart`, listener);
    document.addEventListener(`keyup`, handleEscape);
    return (): void => {
      document.removeEventListener(`mousedown`, listener);
      document.removeEventListener(`touchstart`, listener);
      document.removeEventListener(`keyup`, handleEscape);
    };
    // Reload only if ref or handler changes
  }, [ref, handler]);
};
